/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const newspaper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 13.85V3.015M8 13.85s-1.529-1.695-6.689-1.765A.32.32 0 0 1 1 11.762V1.573c0-.086.034-.169.095-.23a.315.315 0 0 1 .227-.093C6.472 1.318 8 3.015 8 3.015M8 13.85s1.529-1.695 6.689-1.765a.32.32 0 0 0 .311-.323V1.573a.325.325 0 0 0-.095-.23.315.315 0 0 0-.227-.093C9.528 1.318 8 3.015 8 3.015M6 7c-1.059-.356-1.886-.537-3-.617M6 9.65c-1.059-.356-1.886-.577-3-.656M10 7c1.059-.356 1.886-.42 3-.5m-3 3.15c1.059-.356 1.886-.577 3-.656"
    />
  </svg>
)
export default newspaper
